module.exports = __webpack_public_path__ + "static/media/productfeaturesintegration.e08cd2d0.png";